export const locale = {
    lang: 'ds',
    data: {
        'Headers': {
            'QuestionList': 'Spørg kunden om årsagen til afvisning:'
        },
        'QuestionTypeCategory': {
            'value1': 'Textbox',
            'value2': 'Multi Choice',
            'value3': 'Single Choice',
            'value4': 'Rating'
        },
        'BUTTONS': {
            'NEWPROJECTOFFER': 'Nyt Sag tilbud',
            'AddQuestion': 'Tilføj spørgsmål',
            'Save': 'Gem',
            'Cancel': 'Gå tilbage',
            'Text': 'Tekst',
            'Add': 'Tilføj',
        },
        'FIELDS': {
            'Question': 'Spørgsmål',
            'SrNo': 'Sr nr.',
            'Type': 'Type',
            'Answer': 'Svar'
        },
        'VALIDATIONS': {
            'QuestionRequired': 'Spørgsmål påkrævet'
        },
        'MESSAGES': {
            'NoQuestionAnswerFound': 'Ingen Spørgsmål Fundet.',
            'AddTypeList': 'Tilføj mindst en værdi i typelisten.'
        },
    }
}